import React, { Component } from 'react'
import Select from 'react-select'
import axios from 'axios'
import swal from 'sweetalert'
import ls from 'local-storage'

export class Beneficiary extends Component {
    constructor(props){     
        super(props);   
        this.state = {
          errors: {},
          details:{},
          formdetails:{},
          parlimentoryconstituency:[],
          assemblyconstituency:[],
          talukalist:[],
          entrydata:[],
          constituency:[],
          parconstituency:[],
          savedata:{'workhead':this.props.children.workhead,'partworkhead':this.props.children.partworkhead,'officecode':this.props.children.officecode},
          taluka:[],
         }  
        this.selecthandleChange = this.selecthandleChange.bind(this);  
        this.getdataafterload = this.getdataafterload.bind(this); 
        this.ParlimenteryConstituencyDelete = this.ParlimenteryConstituencyDelete.bind(this); 
      }    
      componentDidMount() {
        document.title = "Partwork Basic Details"
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;        
        if(this.props.children){
            Axios.get(`${process.env.REACT_APP_API_URL}partworks/partworkdata/workhead/`+ this.props.children.workhead + `/partworkhead/` + this.props.children.partworkhead + `/officecode/` + this.props.children.officecode)
            .then(result=>{
              if(result.status === 200){
                this.setState({details:result.data});  
                this.getdataafterload();                        
              }      
            });
                               
        }
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/searparchconstituency`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.parconcd,
              "label" : d.parconname          
            }))    
            this.setState({parlimentoryconstituency: options})  
          }           
        });  
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/searchconstituency`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.concd,
              "label" : d.conname          
            }))    
            this.setState({assemblyconstituency: options})  
          }           
        });  
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/searchtaluka`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.tcode,
              "label" : d.name_e          
            }))    
            this.setState({talukalist: options})  
          }           
        });                    
      } 
      async getdataafterload()
      {
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;           
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/partworkbenefy/workhead/`+ this.props.children.workhead + `/partworkhead/` + this.props.children.partworkhead + `/officecode/` + this.props.children.officecode)
        .then(result=>{
          if(result.status === 200){
            this.setState({constituency:result.data.constituency});                      
            this.setState({parconstituency:result.data.parconstituency});                      
            this.setState({taluka:result.data.taluka});                      
          }      
        }); 
      } 
      parconstituncyForm(e){        
        e.preventDefault();
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const savedata =  this.state.savedata;
          savedata['concd'] = this.state.formdetails.parconcd;
          savedata['constype'] = 'P';
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/saveparconstituncy`, savedata) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
              if(result.status === 1){
                this.getdataafterload();     
                swal({
                  title: result.msg,
                  text: "Parlimentory Constituency",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });   
      }      
      assemblyconstituncyForm(e){        
        e.preventDefault();
        console.log(e);
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const savedata =  this.state.savedata;
          savedata['concd'] = this.state.formdetails.concd;
          savedata['constype'] = 'A';
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/saveparconstituncy`, savedata) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
              if(result.status === 1){
                this.getdataafterload();    
                swal({
                  title: result.msg,
                  text: "Assembly Constituency",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });   
      }        
      talukaForm(e){        
        e.preventDefault();
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const savedata =  this.state.savedata;
          savedata['tcode'] = this.state.formdetails.tcode;
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/savetaluka`, savedata) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
                this.getdataafterload();    
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "Taluka",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });   
      }  
      async ParlimenteryConstituencyDelete(pcode,id){    
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const savedata =  this.state.savedata;
          savedata['concode'] = pcode;
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/deleteparchconstituency`, savedata) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
                this.getdataafterload();    
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "Parlimentery Constituency Delete Suceessfully",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });          
      }      
       
      async AssemblyConstituencyDelete(code,id){    		
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const savedata =  this.state.savedata;
          savedata['concode'] = code;
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/deletechconstituency`, savedata) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
                this.getdataafterload();    
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "Parlimentery Constituency Delete Suceessfully",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });
      }      
      async TalukaDelete(tcode,id){    		
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const savedata =  this.state.savedata;
          savedata['talukacode'] = tcode;
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/deletetaluka`, savedata) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
                this.getdataafterload();    
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "Taluka Delete Suceessfully",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });
      }           
      async selecthandleChange(name,e) {
        let formdetails = this.state.formdetails; 
        formdetails[name] = e.value;  
        this.setState({formdetails});        
      }   

    render() {
        return (
                        <div className="box">
                            <div className="box-body">
                                <div className="box-header">
                                <div className="col-md-12">
                                    <h3 className="box-title">Work</h3>
                                    <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td>Work Type :</td>
                                            <td>{this.state.details.worktypename  || '' }</td>
                                            <td>Zone :</td>
                                            <td>{this.state.details.ceofficename  || '' }</td>
                                        </tr>
                                        <tr>
                                            <td>Scheme :</td>
                                            <td>{this.state.details.schemename  || '' }</td>
                                            <td>Circle  :</td>
                                            <td>{this.state.details.seofficename  || '' }</td>
                                        </tr>
                                        <tr>
                                            <td>State Share :</td>
                                            <td>{this.state.details.stateshare  || '' }%</td>
                                            <td>Division  :</td>
                                            <td>{this.state.details.eeofficename  || '' }</td>
                                        </tr>
                                        <tr>
                                            <td>Centre Share :</td>
                                            <td>{this.state.details.centreshare  || '' }%</td>
                                            <td>Work Category :</td>
                                            <td>{this.state.details.workcategory  || '' }</td>
                                        </tr>	
                                        </tbody>				
                                    </table>
                                </div>	
                                </div>	
                            <hr></hr>
                    <div className="col-md-12">
                    <h3 className="text-center"> Parlimentory Constituency</h3>
                    <form onSubmit= {this.parconstituncyForm.bind(this)} >
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="control-label">Parlimentory Constituency</label>
                            <Select 
                            options={this.state.parlimentoryconstituency} 
                            name="parconcd"  
                            isClearable
                            onChange={this.selecthandleChange.bind(this,'parconcd')} />      
                        </div>
                    </div>
                    <div className="col-md-6" style={{'padding':'2.3%'}}>
                            <input type="submit" className="btn btn-primary" value="Save" /> 
                    </div> 
                    </form>                   
                    <div className="col-md-12">
                        <table className="table table-bordered text-center">
                            <thead>
                                <tr className="text-primary">
                                    <th>Code</th>
                                    <th>Parlimentery Constituency Name</th>
                                    <th>Delete</th>
                                </tr> 
                            </thead>
                            <tbody>
                            {this.state.parconstituency.map((value, index) => {
                                return (
                                    <tr key={value.parconcd}>
                                        <td>{value.parconcd}</td>
                                        <td>{value.parconname}</td>
                                        <td><button onClick={this.ParlimenteryConstituencyDelete.bind(this,value.parconcd)} className="btn btn-primary btn-sm"><i className="fa fa-trash"></i></button></td>
                                    </tr>
                                )
                            })} 
                            </tbody>                           
                        </table>
                        </div>
                    </div>
                    <div className="col-md-12">
                    <h3 className="text-center">Assembly Constituency</h3>
                    <form onSubmit= {this.assemblyconstituncyForm.bind(this)} >
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="control-label">Assembly Constituency</label>
                            <Select 
                            options={this.state.assemblyconstituency} 
                            name="concd"  
                            isClearable
                            onChange={this.selecthandleChange.bind(this,'concd')} />      
                        </div>
                    </div>
                    <div className="col-md-6" style={{'padding':'2.3%'}}>
                            <input type="submit" className="btn btn-primary" value="Save" /> 
                    </div> 
                    </form>                    
                    <div className="col-md-12">
                        <table className="table table-bordered text-center">
                        <thead>
                            <tr className="text-primary">
                                <th>Code</th>
                                <th>Assembly Constituency Name</th>
                                <th>Delete</th>
                            </tr>
                            </thead>  
                            <tbody>
                            {this.state.constituency.map((value, index) => {
                                return (
                                    <tr key={value.concd}>
                                        <td>{value.concd}</td>
                                        <td>{value.conname}</td>
                                        <td><button onClick={this.AssemblyConstituencyDelete.bind(this,value.concd)} className="btn btn-primary btn-sm"><i className="fa fa-trash"></i></button></td>
                                    </tr>
                                )
                            })} 
                            </tbody>    	   
                        </table>
                        </div>
                        </div>
                    <div className="col-md-12">
                    <h3 className="text-center">Taluka</h3>
                    <form onSubmit= {this.talukaForm.bind(this)} >
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="control-label">Taluka</label>
                            <Select 
                            options={this.state.talukalist} 
                            name="tcode"  
                            isClearable
                            onChange={this.selecthandleChange.bind(this,'tcode')} />      
                        </div>
                    </div>
                    <div className="col-md-6" style={{'padding':'2.3%'}}>
                            <input type="submit" className="btn btn-primary" value="Save" /> 
                    </div> 
                    </form>                  
                    <div className="col-md-12">
                        <table className="table table-bordered text-center">
                        <thead>
                            <tr className="text-primary">
                                <th>Code</th> 
                                <th>Taluka Name</th> 
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.taluka.map((value, index) => {
                                return (
                                    <tr key={value.talukacode}>
                                        <td>{value.talukacode}</td>
                                        <td>{value.name_e}</td>
                                        <td><button onClick={this.TalukaDelete.bind(this,value.talukacode)} className="btn btn-primary btn-sm"><i className="fa fa-trash"></i></button></td>
                                    </tr>
                                )
                            })} 
                            </tbody> 
                        </table>
                    </div>			
                            </div>
                            </div>
                </div>
        )
    }
}

export default Beneficiary
